import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, calculateProductPrice, decrementQuantity, removeFromCart } from '../redux/cart/actionCreator';
import { DECREMENT_QUANTITY } from '../redux/cart/actionTypes';
import { decrementStock, incrementStock } from '../redux/products/actionCreator';

const CartCard = ({product}) => {
    const dispatch = useDispatch();
    const {category, name, price, thumbnail, quantity, total, id} = product;
    const {products} = useSelector((state) => state.product);
    let selectedProduct = products.find((product) => product.id === id);


    useEffect(() => {
      dispatch(calculateProductPrice(product))
    },[])

    // add quantiy of product on cart
    const handleIncrement = () => {
      dispatch(addToCart(product));
      dispatch(decrementStock(product));
      dispatch(calculateProductPrice(product));
    }

  const handleDecrement = () => {
      dispatch(decrementQuantity(product));
      dispatch(calculateProductPrice(product));
      dispatch(incrementStock(id, 1));

    }

  const handleRemove = () => {
    dispatch(removeFromCart(id));
    dispatch(incrementStock(id, quantity))
  }   

    return (
        <div className="cartCard">
            <div className="flex items-center col-span-6 space-x-6">
       {/*        <!-- cart image --> */}
              <img className="lws-cartImage" src={thumbnail} alt="product" />
          {/*     <!-- cart item info --> */}
              <div className="space-y-2">
                <h4 className="lws-cartName">{name}</h4>
                <p className="lws-cartCategory">{category}</p>
                <p>BDT <span className="lws-cartPrice">{price}</span></p>
              </div>
            </div>
            <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
         {/*      <!-- amount buttons --> */}
              <div className="flex items-center space-x-4">
                <button className="lws-incrementQuantity" onClick={handleIncrement} disabled={selectedProduct.stock <= 0}>
                  <i style={selectedProduct.stock <= 0 ? {opacity:"0.3"}: {}} className="text-lg fa-solid fa-plus"></i>
                </button>
                <span className="lws-cartQuantity">{quantity}</span>
                <button className="lws-decrementQuantity" onClick={handleDecrement} disabled={quantity <= 1}>
                  <i style={quantity <= 1 ? {opacity:"0.3"} : {}} className="text-lg fa-solid fa-minus"></i>
                </button>
              </div>
        {/*       <!-- price --> */}
              <p className="text-lg font-bold">BDT <span className="lws-calculatedPrice">{total || 0}</span></p>
            </div>
       {/*      <!-- delete button --> */}
            <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
              <button className="lws-removeFromCart" onClick={handleRemove}>
                <i className="text-lg text-red-400 fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
    );
};

export default CartCard;